export default {
    dialog: {
        container: {
            width: '100%',
            padding: 10,
            backgroundColor: '#fff',
            alignItems: 'center',
            justifyContent: 'center',
        },
        cardContainer: {
            // flex: 1,
        },
        horizontal: {
            marginBottom: 10,
            height: 500,
        },
        horizontalContainer: {
            flexDirection: 'row',
            width: '100%',
        },
        horizontalText: {
            textAlign: 'left',
            fontSize: 16,
            marginVertical: 10,
            width: '30%',
        },
        horizontalValue: {
            marginVertical: 10,
            width: '70%',
            alignItems: 'center',
            justifyContent: 'center',
        },
    },
};
